import { useState } from "react";
import { useShovellerSignupContext } from "../../../../context/shovllerSignupFormContext";
import { Input } from "../../../ui/input";
import { Label } from "../../../ui/label";
import {
  FaUser,
  FaPhone,
  FaCamera,
  FaEdit,
} from "react-icons/fa";
import Resizer from "react-image-file-resizer";
import { StepFooterNav } from "../../shared/NavigationFooter";
import { Avatar, AvatarFallback, AvatarImage } from "../../../ui/avatar";

export function Step3({ nextStep, preStep, currentStep, totalSteps }) {
  const { formData, handleChange, handleImageChange } = useShovellerSignupContext();
  const [selectedImage, setSelectedImage] = useState(formData.image);

  const [errors, setErrors] = useState({
    userName: "",
    phone: "",
    firstName: "",
    lastName: "",
    image: "",
  });

  const handleImageFileChange = (event) => {
    const file = event.target.files[0];
    const validImageTypes = ["image/jpeg", "image/png"];

    if (file && validImageTypes.includes(file.type)) {
      Resizer.imageFileResizer(
        file,
        81,
        77,
        file.type === "image/jpeg" ? "JPEG" : "PNG",
        100,
        0,
        (uri) => {
          setSelectedImage(uri);
          handleImageChange(uri);
        },
        "base64"
      );
    } else {
      setSelectedImage(null);
      handleImageChange(null);
    }
  };

  const validateFields = () => {
    let valid = true;
    const newErrors = { userName: "", phone: "", firstName: "", lastName: "", image: "" };

    if (!formData.firstName) {
      newErrors.firstName = "First name is required.";
      valid = false;
    }
    if (!formData.lastName) {
      newErrors.lastName = "Last name is required.";
      valid = false;
    }
    if (!formData.userName.trim()) {
      newErrors.userName = "Username is required.";
      valid = false;
    }
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(formData.phone)) {
      newErrors.phone = "Phone must be a 10-digit number.";
      valid = false;
    }
    if (!selectedImage) {
      newErrors.image = "Please upload a profile picture.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleNextStep = () => {
    if (validateFields()) {
      nextStep();
    }
  };

  return (
    <div className="flex flex-col px-6 py-10">
      {/* Title */}
      <h2 className="text-2xl font-bold text-gray-900">Personal Information</h2>
      <p className="text-gray-600 mb-8">
        Provide your profile details to continue
      </p>

      <div className="space-y-6">
        {/* Profile Image (fully clickable) */}
        <div className="flex flex-col items-center mb-6 relative">
        <label htmlFor="profileImageInput" className="cursor-pointer relative">
          <Avatar className="w-24 h-24 relative">
            <AvatarImage src={selectedImage} />
            <AvatarFallback>
              <FaUser className="w-10 h-10 text-gray-500" />
            </AvatarFallback>
            {/* Edit icon overlay */}
            <div className="absolute bottom-1 right-2 bg-white rounded-full p-1 shadow-md">
              <FaEdit className="w-6 h-6 text-gray-700" />
            </div>
          </Avatar>
        </label>
        <input
          id="profileImageInput"
          type="file"
          accept="image/*"
          className="hidden"
          onChange={handleImageFileChange}
        />
        {errors.image && (
          <p className="text-xs text-red-500 mt-2">{errors.image}</p>
        )}
      </div>


        {/* First Name */}
        <div>
          <Label className="flex items-center gap-2 mb-2">
            <FaUser className="w-4 h-4" /> First Name
          </Label>
          <Input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            placeholder="Enter your first name"
          />
          {errors.firstName && (
            <p className="text-xs text-red-500 mt-1">{errors.firstName}</p>
          )}
        </div>

        {/* Last Name */}
        <div>
          <Label className="flex items-center gap-2 mb-2">
            <FaUser className="w-4 h-4" /> Last Name
          </Label>
          <Input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            placeholder="Enter your last name"
          />
          {errors.lastName && (
            <p className="text-xs text-red-500 mt-1">{errors.lastName}</p>
          )}
        </div>

        {/* Username */}
        <div>
          <Label className="flex items-center gap-2 mb-2">
            <FaUser className="w-4 h-4" /> Username
          </Label>
          <Input
            type="text"
            name="userName"
            value={formData.userName}
            onChange={handleChange}
            placeholder="Choose a username"
          />
          {errors.userName && (
            <p className="text-xs text-red-500 mt-1">{errors.userName}</p>
          )}
        </div>

        {/* Phone */}
        <div>
          <Label className="flex items-center gap-2 mb-2">
            <FaPhone className="w-4 h-4" /> Phone Number <span className="text-sm opacity-70">(Canadians only)</span>
          </Label>
          <Input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="10-digit phone number"
          />
          {errors.phone && (
            <p className="text-xs text-red-500 mt-1">{errors.phone}</p>
          )}
        </div>
      </div>

      {/* Footer Navigation */}
      <StepFooterNav
        currentStep={currentStep}
        totalSteps={totalSteps}
        onBack={preStep}
        onNext={nextStep}
        nextDisabled={false}
      />
    </div>
  );
}
